import ReactGA from "react-ga4";

/**
 * GA4 초기화
 */
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (measurementId) {
    ReactGA.initialize(measurementId);
  }
};

/**
 * 페이지뷰 전송
 */
export const sendPageView = (path, title) => {
  ReactGA.send({
    hitType: "pageview",
    page: path,
    title: title,
  });
};

/**
 * 커스텀 이벤트 전송
 */
export const sendEvent = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};
